<template>
  <div class="diagnose-wrapper">

    <div class="enter-diagnose">
      <!-- 诊断信息 -->
      <div class="diagnose-section">

        <div class="diagnose-info-item">
          <div class="diagnose-title"><span class="required">就诊人</span></div>
          <div class="info-content">
            <div class="patient-info">{{patientInfo.username}} {{patientInfo.gender | genderFilter}}
              {{patientInfo.birthday | ageFilter}} {{(patientInfo.allergy == '否认') ? '无过敏史' : patientInfo.allergy == '不确定' ? '不确定过敏史' : patientInfo.allergy}}
            </div>
            <div class="patient-province">{{patientInfo.province}} </div>
          </div>
        </div>
        <div class="diagnose-info-item" v-if="photoPresDataID>0">
          <div class="diagnose-title"><span>处方照片</span></div>
          <div class="photo-pres-box" @click="previewImage(photoPresPath, 0)">
            <img :src="photoPresPath" />
          </div>
        </div>
        <div class="diagnose-info-item">
          <div class="diagnose-title"><span class="required">主诉</span></div>
          <div class="info-content">
            <textarea class="info-textarea" v-model="condition" maxlength="100" placeholder="患者病情描述"></textarea>
            <span class="text-limit">{{condition.length}}/100</span>
          </div>
        </div>
        <!--
        <div class="diagnose-info-item" v-if="userInfo.user_id==10032">
          <div class="diagnose-title"><span class="required">疾病</span></div>
          <div class="info-content" @click="showDisease()">
            <div class="disease-judge"></div>

          </div>
        </div>
-->
        <div class="diagnose-info-item">
          <div class="diagnose-title"><span class="required">诊断</span></div>
          <div class="info-content">
            <textarea class="info-textarea" v-model="diagnoseText" maxlength="100" placeholder="诊断描述"></textarea>
            <span class="text-limit">{{diagnoseText.length}}/100</span>
          </div>
        </div>
      </div>
      <!--
      <div class="form-item click"  @click="companySelect = true">
        <div class="form-type"><span class="required">选择药房</span></div>
        <div class="form-content">
          <div class="picker-tips" v-if="!companyname">请选择
            <icon icon-class="arrow" />
          </div>
          <div class="picker-value" v-else>{{companyname}}</div>
        </div>
      </div>
      -->
      <!-- 处方信息 -->
      <div class="diagnose-section">
        <div class="prescription-box">
          <div class="prescription-type">{{formulationType | formulationTypeFilter}}</div>
          <div class="prescription-header">
            <h4>R:</h4>
          </div>
          <div class="prescription-content">{{herbListString}}</div>
        </div>

        <div class="prescription-control">

          <button class="prescription-button" v-if="herbList.length <= 0" @click="editNewScript">添加处方</button>
          <button class="prescription-button" v-else @click="editScript">编辑处方</button>
        </div>
        <!--
        <div class="prescription-control" v-else>

          <button class="prescription-button" v-if="herbList.length <= 0" @click="editNewScript">添加处方</button>
          <button class="prescription-button" v-else @click="editScript">编辑处方</button>
        </div>
-->
      </div>
      <!-- 用法用量信息 -->
      <div class="diagnose-section">
        <div class="dosage-item">
          <div class="diagnose-title"><span>用法用量</span></div>
          <div class="dosage-content">
            <div class="dosage-control-item">
              <div class="dosage-type">剂量</div>
              <div class="dosage-control-content">
                <stepper v-model="dosage" :max="999" :integer="true"></stepper>
                <span>剂</span>
              </div>
            </div>
            <div class="dosage-control-item">
              <div class="dosage-type">用量</div>
              <div class="dosage-control-content">
                <stepper v-model="dosagePerDay" :max="999"></stepper>
                <span>剂/天</span>
              </div>
            </div>
            <div class="dosage-control-item">
              <div class="dosage-type">用法</div>
              <div class="dosage-control-content usage">
                <div class="dosage-selector">
                  <div class="selector-item" :class="{'selected': usage == 1}" @click="chooseUsage(1)">内服</div>
                  <div class="selector-item" :class="{'selected': usage == 2}" @click="chooseUsage(2)">外用</div>
                </div>
              </div>
            </div>
            <div class="dosage-number" v-if="usage == 1">每剂分<span class="dosage-number-input">
                <number-input v-model="perDosage" :min="1" :max="99" />次</span>服用</div>
          </div>
        </div>
        <div class="dosage-item">
          <div class="diagnose-title"><span>注意事项</span></div>
          <div class="dosage-content">
            <div class="dosage-textarea">
              <textarea class="info-textarea" v-model="attentionText" v-ios-bug-fixed maxlength="100" placeholder="医嘱"></textarea>
              <span class="text-limit">{{attentionText.length}}/100</span>
            </div>
            <div class="puick-attention">
              <h4 class="attention-title">服药时间</h4>
              <div class="attention-list">
                <div class="attention-item" @click="puickFillAttention(item)" v-for="item in attentionTimeData">{{item}}</div>
              </div>
            </div>
            <div class="puick-attention">
              <h4 class="attention-title">忌口与禁忌</h4>
              <div class="attention-list">
                <div class="attention-item" @click="puickFillAttention(item)" v-for="item in attentionTabooData">{{item}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 超用量签章信息 -->
      <div class="diagnose-section" v-if="excessHerbs.length > 0 || tabooData.length > 0">
        <div class="over-dose-box">
          <div class="over-tips"><template v-if="excessHerbs.length > 0">{{excessHerbs.join('、')}}超出药典建议最大剂量，</template><template
              v-if="tabooData.length > 0">{{tabooData.join('、')}}存在配伍禁忌，</template><span>确认已知晓</span></div>
          <div class="sign-box">
            <div class="type">医生签章</div>
            <div class="signature" v-if="moulage_image==''">
              <span>{{userInfo.username}}</span>
              <p>{{patientInfo.doc_id}}</p>
            </div>
            <img :src="moulage_image" style="width:60px; " />
          </div>
        </div>
      </div>
      <!-- 价格信息 -->
      <div class="diagnose-section">
        <!--
        <div class="price-item">
          <div class="price-type">药材费</div>
          <div class="normal-price">¥ {{parseFloat(normalPrice).toFixed(2)}}</div>
        </div>
        <div class="price-item">
          <div class="price-type">价格浮动</div>
          <div class="normal-price">
            <div class="float-switcher" :class="{'minus': floatType == 'minus'}">
              <div class="switcher-item" @click="changeFloat('plus')">上浮</div>
              <div class="switcher-item" @click="changeFloat('minus')">下调</div>
            </div>
          </div>
        </div>
        <div class="price-item">
          <div class="price-type float-price">
            浮动范围
            <p>(-10% ~ +20%)</p>
          </div>
          <div class="float-control">
            <span>
              <icon :icon-class="floatType"></icon>
            </span>
            <number-input class="percent" v-model="floatPricePercent" :min="0" :max="maxFloat" />
            <span>%</span>
          </div>
        </div>
-->
        <!-- 剂型为中药饮片时显示是否代做膏方 -->
        <div class="price-item" v-if="formulationType == 1">
          <div class="price-type">代做膏方<span>*</span></div>
          <div class="paste-selector">
            <div class="selector-item" :class="{'selected': selectedPaste == 1}" @click="selectPaste(1)">是</div>
            <div class="selector-item" :class="{'selected': selectedPaste == 2}" @click="selectPaste(2)">否</div>
          </div>
        </div>
        <div class="price-item" v-if="formulationType == 1 && selectedPaste == 1">
          <div class="price-type">膏方制作费</div>
          <div class="normal-price">¥ {{parseFloat(pastePrice).toFixed(2)}}</div>
        </div>
        <div class="total-price">
          <div class="total">费用合计</div>
          <div class="price" :class="{'grey': parseFloat(finalPrice) == 0}">¥ {{finalPrice | int}}<span>{{finalPrice | float}}</span></div>
        </div>
      </div>
      <div class="diagnose-bottom-control">
        <!--
        <button class="botton-button save" @click="saveTemplate" :disabled="savedTemplate">保存为处方模板</button>
        -->
        <button class="botton-button send" @click="sendScriptTip">提交</button>
      </div>

      <van-popup v-model="companySelect" position="bottom">
        <van-picker show-toolbar :columns="companyData" value-key="label" @cancel="companySelect = false" @confirm="confirmCompany" />
      </van-popup>
      <!-- 弹窗 -->
      <!-- 保存处方模板弹窗 -->
      <x-dialog v-if="saveToTemplateShow" title="保存为处方模板" @close="saveToTemplateShow = false">
        <div class="save-content">
          <div class="save-input">
            <div class="save-title">模板名称</div>
            <div class="save-text">
              <input type="text" class="save-typer" maxlength="15" v-model="saveTemplateName" placeholder="请输入处方名称">
              <span class="text-limit">{{saveTemplateName.length}}/15</span>
            </div>
          </div>
          <div class="save-control">
            <button class="cancel" @click="saveToTemplateShow = false">取消</button>
            <button class="confirm" @click="saveTemplateAction" :disabled="scriptSaving">保存</button>
          </div>
        </div>
      </x-dialog>
      <!-- 发送给患者弹窗 -->
      <x-dialog v-if="sendScriptShow" title="发送处方" @close="sendScriptShow = false">
        <div class="dialog-content">
          <div class="warning-text" v-if="overDosage">当前处方用量超过7天，请确认已知晓，并将处方发送给患者</div>
          <div class="text" v-else>是否将处方发送给患者</div>
          <div class="control">
            <button class="cancel" @click="sendScriptShow = false">再修改一下</button>
            <button class="confirm" @click="sendScript">确定</button>
          </div>
        </div>
      </x-dialog>
      <van-image-preview v-model="previewShow" :images="previewList" :start-position="imageIndex"></van-image-preview>

    </div>
  </div>
</template>

<style lang="less" scoped>

  .diagnose-wrapper{
    min-height: 100vh;
    background: #F7F7F7;
    width: 100%;
    padding: 12px 8px 0;
    .company-select-panel{
      width: 100%;
      height: 150px;
      background-color: #fff;
      border-top-right-radius: 5px;
      border-top-left-radius: 5px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      .company-item{
        width: 80px;
        height: 80px;
        border:solid 1px #3668A6;
        border-radius: 50%;

      }
    }
    .diagnose-section{
      margin-bottom: 12px;
      background: #FFF;
      border-radius: 6px;
      padding: 24px 16px 1px;
      .diagnose-title{
        font-size: 16px;
        line-height: 16px;
        color: #666;
        font-weight: bold;
        span{
          position: relative;
          &.required::after{
            content: '*';
            position: absolute;
            left: 100%;
            top: 0;
            font-size: 16px;
            line-height: 16px;
            color: @error;
            margin-left: 1px;
          }
        }
      }
      .selector-item{
        height: 32px;
        padding: 0 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid #E0E6E6;
        background: #F7F7F7;
        color: #999;
        font-size: 14px;
        cursor: pointer;
        border-radius: 4px;
        transition: all .1s;
        &:first-child{
        margin-right: 16px;
        }
        &.selected{
          border-color: @xile;
          background: @xile;
          color: #FFF;
        }
      }
      .info-textarea{
        width: 100%;
        height: 96px;
        background: #F7F7F7;
        border-radius: 4px;
        padding: 12px;
        font-size: 14px;
        line-height: 20px;
        color: @black;
        resize: none;
      }
      .text-limit{
        position: absolute;
        right: 8px;
        bottom: 8px;
        font-size: 12px;
        line-height: 12px;
        color: #999;
      }
      .diagnose-info-item{
        margin-bottom: 32px;
        .photo-pres-box{
          margin-top: 10px;
          width: 150px;
          max-height: 100px;
          overflow: hidden;
          border:dashed 1px #ddd;
          img{
            display: block;
            margin:5px auto;
            width: 98%;
          }
        }
        .info-content{
          margin-top: 12px;
          position: relative;
          .disease-judge{
            width: 100%;
            height: 30px;
            background: #F7F7F7;
            border-radius: 4px;
            padding: 12px;
            font-size: 14px;
            line-height: 20px;
            color: @black;
          }
          .patient-info{
            font-size: 18px;
            line-height: 20px;
            color: @black;
            font-weight: bold;
          }
          .patient-province{
            padding-top:10px;
            font-size: 15px;
            line-height: 17px;
            color: #474747;
            font-weight: 0;
          }
        }
      }
      .prescription-box{
        .prescription-type{
          font-size: 16px;
          color: #666;
          line-height: 16px;
          margin-bottom: 36px;
          font-weight: bold;
        }
        .prescription-header{
          display: flex;
          justify-content: space-between;
          align-items: center;
          h4{
            font-size: 18px;
            line-height: 18px;
            color: @black;
            font-weight: bold;
          }
          .new-prescription{
            display: flex;
            justify-content: flex-end;
            align-items: center;
            font-size: 14px;
            line-height: 14px;
            color: #999;
            svg{
              font-size: 12px;
              color: #999;
              margin-right: 4px;
            }
            &.enable{
              color: @xile;
              svg{
                color: @xile;
              }
            }
          }
          .edit-prescription{
            display: flex;
            justify-content: flex-end;
            align-items: center;
            font-size: 14px;
            line-height: 14px;
            color: #666;
            svg{
              font-size: 14px;
              color: #CCC;
            }
          }
        }
        .prescription-content{
          width: 100%;
          padding: 8px 0 16px;
          min-height: 33px;
          font-size: 14px;
          line-height: 28px;
          color: @black;
          font-weight: bold;
        }
      }
      .prescription-control{
        padding: 20px 0;
        display: flex;
        justify-content: center;
        align-items: center;
        border-top: 1px solid #F3F3F3;
        .prescription-button{
          @button-base();
          @button-border();
          width: 156px;
          height: 36px;
          &:disabled{
            border-color: #CCC;
            color: #CCC;
          }
        }
      }
      .dosage-item{
        margin-bottom: 32px;
        .dosage-content{
          margin-top: 12px;
          .dosage-control-item{
            margin-top: 28px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .dosage-type{
              width: 64px;
              font-size: 16px;
              line-height: 16px;
              color: @black;
            }
            .dosage-control-content{
              flex: 1;
              display: flex;
              justify-content: flex-start;
              align-items: center;
              span{
                margin-left: 16px;
                font-size: 16px;
                color: @black;
              }
              .dosage-selector{
                display: flex;
                justify-content: flex-start;
                align-items: center;
              }
            }
          }
          .dosage-number{
            margin: 16px 0 0 64px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            height: 36px;
            font-size: 16px;
            line-height: 20px;
            color: @black;
            .dosage-number-input{
              margin: 0 8px 0 6px;
              width: 56px;
              height: 36px;
              background: #F7F7F7;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 14px;
              color: #999;
              border-radius: 4px;
              input{
                width: 25px;
                text-align: center;
                font-size: 16px;
                color: @black;
                font-weight: bold;
                background: transparent;
              }
            }
          }
          .dosage-textarea{
            position: relative;
          }
        }
        .puick-attention{
          padding-top: 16px;
          h4{
            font-size: 13px;
            color: #666;
            font-weight: normal;
          }
          .attention-list{
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            flex-wrap: wrap;
            .attention-item{
              height: 30px;
              line-height: 30px;
              margin: 16px 16px 0 0;
              background: #FAFAFA;
              font-size: 14px;
              padding: 0 10px;
              color: #999;
              border-radius: 4px;
            }
          }
        }
      }
      .over-dose-box{
        .over-tips{
          position: relative;
          font-size: 14px;
          line-height: 20px;
          padding-left: 10px;
          color: @error;
          font-weight: bold;
          span{
            color: #666;
          }
          &::after{
            content: '';
            position: absolute;
            left: 0;
            top: 8px;
            width: 4px;
            height: 4px;
            border-radius: 50%;
            background: @error;
          }
        }
        .sign-box{
          margin-top: 19px;
          margin-bottom: 23px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          .type{
            font-size: 14px;
            line-height: 14px;
            color: #666;
            font-weight: bold;
          }
          .signature{
            position: relative;
            padding: 4px 4px 1px 4px;
            border: 1px solid #CA1F24;
            color: #CA1F24;
            text-align: center;
            font-weight: bold;
            font-size: 12px;
            line-height: 12px;
            border-radius: 2px;
            p{
              margin-top: 3px;
            }
            &::after{
              content: '';
              position: absolute;
              top: 17px;
              left: 50%;
              transform: translateX(-50%);
              width: calc(100% - 8px);
              height: 1px;
              background: #CA1F24;
            }
          }
        }
      }
      .price-item{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-top: 8px;
        margin-bottom: 24px;
        .price-type{
          font-size: 15px;
          line-height: 20px;
          color: @black;
          font-weight: bold;
          &.float-price{
            color: #666;
          }
          p{
            font-size: 14px;
            line-height: 20px;
            color: #666;
          }
          span{
            color: @error;
          }
        }
        .normal-price{
          font-size: 16px;
          line-height: 16px;
          font-weight: bold;
          color: @black;
          .float-switcher{
            position: relative;
            width: 128px;
            height: 28px;
            border: 1px solid #E0E6E6;
            background: #F7F7F7;
            border-radius: 4px;
            display: flex;
            justify-content: space-around;
            align-items: center;
            &::after{
              content: '';
              position: absolute;
              top: -1px;
              left: 0;
              width: 64px;
              height: 28px;
              background: @xile;
              border-radius: 4px;
              transition: all .2s;
            }
            &.minus{
              &::after{
                left: 50%;
              }
              .switcher-item:last-child{
                color: #FFF;
              }
              .switcher-item:first-child{
                color: #999;
              }
            }
            .switcher-item{
              position: relative;
              width: 50%;
              height: 100%;
              z-index: 10;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 12px;
              color: #999;
              &:first-child{
                color: #FFF;
              }
            }
          }
        }
        .float-control{
          display: flex;
          justify-content: flex-end;
          align-items: center;
          .percent{
            width: 48px;
            height: 36px;
            background: #F7F7F7;
            text-align: center;
            border-radius: 4px;
            font-weight: bold;
            color: @black;
          }
          span{
            margin-left: 4px;
            font-size: 16px;
            line-height: 16px;
            font-weight: bold;
            color: #999;
            svg{
              font-size: 12px;
              color: #999;
              margin-right: 8px;
            }
          }
        }
        .paste-selector{
          display: flex;
          justify-content: flex-end;
          align-items: center;
        }
      }
      .total-price{
        height: 80px;
        border-top: 1px solid #EEE;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .total{
          font-size: 20px;
          line-height: 20px;
          color: @black;
          font-weight: bold;
        }
        .price{
          position: relative;
          font-size: 24px;
          font-weight: bold;
          color: @xile;
          span{
            font-size: 18px;
          }
          &.grey{
            color: #999;
          }
        }
      }
    }
    .diagnose-bottom-control{
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 12px 0;
      .botton-button{
        @button-base();
        height: 40px;
        &.save{
          width: 128px;
          @button-border();
          .xile-alpha(0.05);
          &:disabled{
            opacity: .6;
          }
        }
        &.send{
          margin-left: 15px;
          flex: 1;
        }
      }
    }
    .dialog-content{
      padding: 40px 0 32px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .warning-text{
        width: 80%;
        font-size: 15px;
        line-height: 21px;
        font-weight: bold;
        color: @black;
      }
      .text{
        font-size: 16px;
        line-height: 16px;
        color: @black;
        font-weight: bold;
        span{
          margin-left: 4px;
          color: @error;
        }
      }
      .control{
        margin-top: 36px;
        display: flex;
        justify-content: center;
        align-items: center;
        button{
          @button-base();
          height: 36px;
          font-size: 14px;
          width: 136px;
          &.cancel{
            background: #FFF;
            border: 1px solid #999;
            color: #999;
            margin-right: 15px;
          }
          &.confirm{}
        }
      }
    }
    .save-content{
      padding: 29px 0 47px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .save-input{
        .save-title{
          font-size: 14px;
          line-height: 14px;
          color: #666;
          font-weight: bold;
        }
        .save-text{
          position: relative;
          width: 287px;
          height: 48px;
          background: #F7F7F7;
          border-radius: 4px;
          margin-top: 12px;
          overflow: hidden;
          .save-typer{
            width: 100%;
            padding: 17px 12px;
            font-size: 14px;
            line-height: 14px;
            color: @black;
            background: #F7F7F7;
          }
          .text-limit{
            position: absolute;
            bottom: 8px;
            right: 8px;
            font-size: 12px;
            line-height: 12px;
            color: #999;
          }
        }
      }
      .save-control{
        margin-top: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
        button{
          @button-base();
          height: 36px;
          font-size: 14px;
          width: 136px;
          &.cancel{
            background: #FFF;
            border: 1px solid #999;
            color: #999;
            margin-right: 15px;
          }
          &.confirm{}
        }
      }
    }

  }
</style>

<script type="text/javascript">
  import xDialog from '@/components/Common/dialog'
  import stepper from '@/components/Common/stepper'
  import numberInput from '@/components/Common/numberInput'
  export default {
    data() {
      return {
        //新增是否是拍方上传的数据
        isPhotoData: 0,
        photoPresDataID: 0,
        photoPresPath: '',
        //快递费
        expressage: 0,
        //医师签名
        moulage_image: '',
        //医师星级服务
        doc_star: 2,
        //增幅
        increase: false,
        // 处方剂型
        formulationType: parseInt(this.$route.query.type),
        // 膏方制作费
        pastePrice: 400,
        // 患者信息
        patientInfo: {},
        // 主诉
        condition: '',
        // 诊断
        diagnoseText: '',
        // 药方
        herbList: [],
        // 超量药
        excessHerbs: [],
        // 禁忌药
        tabooData: [],
        // 剂量
        dosage: 1,
        // 用量
        dosagePerDay: 1,
        // 用法
        usage: null,
        // 内服 每剂分X次
        perDosage: 2,
        // 注意事项
        attentionText: '',
        attentionTimeData: ['饭前一小时服', '饭后一小时服', '空腹服', '晨起服'],
        attentionTabooData: ['无', '忌辛辣', '忌油腻', '忌生冷', '忌烟酒', '忌发物', '忌荤腥', '忌酸涩', '忌刺激性食物', '忌光敏性食物', '忌难消化食物', '备孕禁服',
          '怀孕禁服', '经期停服', '感冒停服'
        ],
        // 代做膏方
        selectedPaste: 2,
        // 价格
        // normalPrice: 0,
        // 每剂药方单价
        univalent: 0,
        // 浮动类型
        floatType: 'plus',
        maxFloat: 20,
        // 浮动价格百分比
        floatPricePercent: 0,
        // 提成价格
        pushMoney: null,
        // 弹窗相关数据
        // 历史处方
        popuppShow: false,
        popupType: 1, //1:历史处方 2:处方模板
        popupTitle: '选择历史处方',
        prescriptionHistoryData: [],
        prescriptionTemplateData: [],
        // 发送处方给患者
        sendScriptShow: false,
        // 保存为处方模板
        saveTemplateName: '',
        saveToTemplateShow: false,
        scriptSaving: false,
        savedTemplate: false,
        previewShow: false,
        previewList: [],
        imageIndex: 0,
        dieaseJudgeShow: false,
        searchKey: '',
        companySelect: false,
        companyname: parseInt(this.$route.query.type),
        companyData: [],

      }
    },
    computed: {
      userInfo() {
        return this.$store.state.userInfo;
      },
      // 正常价格
      normalPrice() {
        return this.univalent * this.dosage;
      },
      expressPrice() {
        let expressage = 10;
        let normalPrice = this.normalPrice;
        if (normalPrice == 0) {
          expressage = 0;
        } else if (normalPrice > 0 && normalPrice < 200) {
          expressage = 10;
        } else if (normalPrice >= 200 && normalPrice < 1000) {
          expressage = 20;
        } else if (normalPrice >= 1000) {
          expressage = 30;
        }
        return expressage;
      },
      // 最终价格
      finalPrice() {
        //const discount = this.floatType == 'plus' ? true : false;
        //let expressage = 0
        let normalPrice = this.normalPrice; //this.univalent * this.dosage;
        let pastePrice = this.selectedPaste == 1 ? this.pastePrice : 0;
        let returnValue = 0;
        if (this.increase) {
          returnValue = normalPrice + (normalPrice * (this.floatPricePercent / 100)) + pastePrice + this.expressPrice;
        } else {
          returnValue = normalPrice - (normalPrice * (this.floatPricePercent / 100)) + pastePrice + this.expressPrice;
        }
        return returnValue;
      },
      // 处方字符串
      herbListString() {
        let list = [];
        if (this.herbList.length > 0) {
          this.herbList.forEach(item => {
            let string = `${item.name} ${item.num}${item.unit} ${item.remark ? '(' + item.remark + ')' : ''}`;
            list.push(string)
          })
        }
        return list.join('、');
      },
      // 混合需要保存到store中的数据
      mixedData() {
        return {
          // 主诉
          condition: this.condition,
          // 诊断
          diagnoseText: this.diagnoseText,
          // 药方
          herbList: this.herbList,
          excessHerbs: this.excessHerbs,
          tabooData: this.tabooData,
          // 是否代做膏方
          selectedPaste: this.selectedPaste,
          // 剂量
          dosage: this.dosage,
          // 用量
          dosagePerDay: this.dosagePerDay,
          // 用法
          usage: this.usage,
          // 内服 每剂分X次
          perDosage: this.perDosage,
          // 注意事项
          attentionText: this.attentionText,
          // 价格浮动类型
          floatType: this.floatType,
          // 价格浮动
          floatPricePercent: this.floatPricePercent,
          // 原价
          univalent: this.univalent,
          // 提成
          pushMoney: this.pushMoney,
          // 超出7天最大用量
          overDosage: false,
          companyname: this.companyname
        }
      }
    },
    components: {
      xDialog,
      stepper,
      numberInput
    },
    created() {
      if (this.$route.query.eleid != undefined && this.$route.query.hasOwnProperty("eleid")) {

        this.photoPresDataID = parseInt(this.$route.query.eleid);
        if (this.photoPresDataID) {
          this.$root.post('/getPhotoPretData', {
            ele_id: this.photoPresDataID
          }).then(data => {
                    console.log('电子处方');
     console.log(data)
let drugTaboo=[];
if(data.drug_taboo!=''){
  drugTaboo=data.drug_taboo.split(',')
}
console.log(drugTaboo)

            if (data.prescription_id > 0) {
              this.$router.replace({
                name: 'PhotoPresResult',
                params: {
                  id: data.prescription_id
                }
              })
            }

            this.photoPresPath = data.electronic_img;
            this.condition = data.self_reported;
            this.diagnoseText = data.diagnose;
            this.dosage = data.dose;
            this.dosagePerDay = data.dosage;
            this.usage = data.use_type;
            this.attentionText = data.advice
            //usage_direction
            if (parseInt(data.use_type) == 1) {
              this.perDosage = data.usage_direction;

            } else {

            }
            // console.log(data);
            var scriptHrebsData = {
              // 药材数据
              content: JSON.parse(data.content),
              // 正常价格
              normalPrice: data.price / 100,
              // 价格（分）
              originPrice: data.price,
              // 超量药数据
              excessData: data.max_dosage ? data.max_dosage.split(',') : [],
              // 禁忌药数据
              tabooData: drugTaboo,
              pushMoney: data.push_money
            }

            var scriptInfo = {};
            scriptInfo.scriptData = scriptHrebsData;
            //console.log(scriptHrebsData)
            this.$store.commit('setPrescriptionData', scriptInfo);
            if (this.$store.state.prescriptionData) {
              let callBackData = this.$store.state.prescriptionData;
              for (let item in callBackData) {
                this[item] = callBackData[item]
              }
              if (callBackData.scriptData && callBackData.scriptData.content) {
                this.univalent = callBackData.scriptData.normalPrice;
                this.herbList = callBackData.scriptData.content;
                this.excessHerbs = callBackData.scriptData.excessData || [];
                this.tabooData = callBackData.scriptData.tabooData || [];
                this.pushMoney = callBackData.scriptData.pushMoney || '';
              }
              // 清空store中储存的临时数据
              this.$store.commit('clearPrescriptionData')
            }

          })
        }
      }
      //前端获得医生星级评定，设置浮动

      // 获取膏方制作费
      this.$root.post('/getPastePrice').then(data => {
        this.pastePrice = parseFloat(data.paste_price) / 100 || 400;
      })
      //获取医生当前星级
      this.$root.post('/getDoctorStar', {
        doc_id: this.userInfo.user_id
      }).then(data => {
        this.doc_star = parseInt(data);
        switch (this.doc_star) {
          case 1:
            this.increase = false;
            this.floatPricePercent = 10;
            break;
          case 2:
            break;
          case 3:
            this.increase = true;
            this.floatPricePercent = 10;
            break;
          case 4:
            this.increase = true;
            this.floatPricePercent = 20;
            break;
          case 5:
            this.increase = true;
            this.floatPricePercent = 30;
            break;
        }
      })
      // 获取患者基本信息以及处方基本信息
      this.$root.post('/getInfo', {
        doc_id: this.userInfo.user_id,
        pat_id: this.$route.query.pat_id
      }).then(data => {
        this.patientInfo = data || {};
        this.moulage_image = data.moulage_image;
        console.log(data)
        console.log('this.$store.state.prescriptionData')
        console.log(this.$store.state.prescriptionData)
        // 若上个页面是处方编辑页面则需要回显之前填写的数据
        if (this.$store.state.prescriptionData) {
          let callBackData = this.$store.state.prescriptionData;
          for (let item in callBackData) {
            this[item] = callBackData[item]
          }
          if (callBackData.scriptData && callBackData.scriptData.content) {
            this.univalent = callBackData.scriptData.normalPrice;
            this.herbList = callBackData.scriptData.content;
            this.excessHerbs = callBackData.scriptData.excessData || [];
            this.tabooData = callBackData.scriptData.tabooData || [];
            this.pushMoney = callBackData.scriptData.pushMoney || '';
          }
          // 清空store中储存的临时数据
          this.$store.commit('clearPrescriptionData')
        }
      })
    },
    methods: {
      previewImage(image, index) {
        //console.log(list)
        this.previewList = [image];
        this.imageIndex = index;
        this.previewShow = true;
      },
      // 选择剂型药房
      pharmacyPickAction() {
        if (this.herbList.length > 0) {
          this.pharmacyPickerWarning = true;
        } else {
          this.pharmacyPickerShow = true;
        }
      },
      changePharmacy() {
        // 确认警告继续重选药房需清除药方数据，超量药品数据，药方价格等数据
        this.herbList = [];
        this.excessHerbs = [];
        this.univalent = 0;
        this.pharmacyPickerWarning = false;
        this.pharmacyPickerShow = true;
      },
      navClick(index) {
        if (this.pharmacyMainActiveIndex == index) {
          return;
        } else {
          this.pharmacyMainActiveIndex = index;
        }
      },
      itemClick(data) {
        this.pharmacyActiveId = data.id;
        this.pharmacyMainId = this.pharmacyData[this.pharmacyMainActiveIndex].id;
        this.pharmacyShowText = {
          type: this.pharmacyData[this.pharmacyMainActiveIndex].text,
          name: data.text
        }
        this.pharmacyPickerShow = false;
      },
      // 是否代煎
      selectDecoction(value) {
        this.selectedDecoction = value;
      },
      // 是否代做膏方
      selectPaste(value) {
        this.selectedPaste = value;
        if (value == 1) {

        }
      },
      confirmCompany(value) {
        console.log(value)
        this.companyname = value.value;
        this.companySelect = false;
        this.$store.commit('setPrescriptionData', this.mixedData);
        this.$router.push({
          path: '/doctor/diagnose/script',
          query: {
            script_type: this.formulationType,
            pat_id: this.$route.query.pat_id,
            company_name: this.companyname
          }
        });
      },
      // 编辑新处方
      editNewScript2() {
        this.companyData = [{
            label: '康仁堂药业',
            value: 2
          },
          {
            label: '江阴天江药业',
            value: 3
          },
        ];
        this.companySelect = true;
        // if(!this.pharmacyActiveId) return;
        // 将当前填写的数据信息存入store，在编辑处方药材完成后需回显此数据
        /*

      */

      },
      // 编辑新处方
      editNewScript() {
        if (this.formulationType == 1) {
          this.companyData = [{
              label: '康美药业',
              value: 1
            },
            {
              label: '黎明药业',
              value: 4
            },

          ];

        } else {
          this.companyData = [{
              label: '康仁堂药业',
              value: 2
            },
            {
              label: '江阴天江药业',
              value: 3
            },
          ];
        }
        this.companySelect = true;

        console.log('editscript')
        // this.companySelect = true;
        // if(!this.pharmacyActiveId) return;
        // 将当前填写的数据信息存入store，在编辑处方药材完成后需回显此数据
        /*

*/
        /*
                this.$store.commit('setPrescriptionData', this.mixedData);
                this.companyname = this.formulationType;
                this.$router.push({
                  path: '/doctor/diagnose/script',
                  query: {
                    script_type: this.formulationType,
                    pat_id: this.$route.query.pat_id,
                    company_name: this.companyname
                  }
                });
                */
      },
      // 编辑已有的处方
      editScript() {
        console.log('editScript')
        console.log(this.companyname)

        this.$store.commit('setPrescriptionData', this.mixedData);
        this.$store.commit('setHerbsData', this.herbList);
        //  this.companyname = this.formulationType;
        this.$router.push({
          path: '/doctor/diagnose/script',
          query: {
            script_type: this.formulationType,
            pat_id: this.$route.query.pat_id,
            company_name: this.companyname
          }
        });
      },
      // 选择用法
      chooseUsage(value) {
        this.usage = value;
      },
      // 快速选择注意事项
      puickFillAttention(item) {
        // 字数即将大于最大值时取消操作
        let text = this.attentionText + `，${item}`;
        if (text.length >= 100) return;
        if (this.attentionText) {
          this.attentionText += `，${item}`;
        } else {
          this.attentionText = item;
        }
      },
      changeFloat(type) {
        if (type == 'plus') {
          this.floatType = 'plus';
          this.maxFloat = 20;
        } else {
          this.floatType = 'minus';
          this.maxFloat = 10;
          if (this.floatPricePercent > this.maxFloat) {
            this.floatPricePercent = this.maxFloat;
          }
        }
      },
      // 发送处方给患者弹窗
      sendScriptTip() {
        if (!this.condition) {
          this.$notify('请填写主诉');
          return;
        }
        if (!this.diagnoseText) {
          this.$notify('请填写诊断');
          return;
        }
        if (this.herbList.length <= 0) {
          this.$notify('请填写处方');
          return;
        }
        // if(!this.dosage) {
        //   this.$notify('请填写剂量');return;
        // }
        // if(!this.dosagePerDay) {
        //   this.$notify('请填写用量');return;
        // }
        if (!this.usage) {
          this.$notify('请选择用法');
          return;
        }
        // if(this.usage == 1 && !this.perDosage) {
        //   this.$notify('请填写用法用量');return;
        // }
        let maxDosageDay = 7;
        let maxDosage = maxDosageDay * this.dosagePerDay;
        if (this.dosage > this.dosagePerDay * maxDosageDay) {
          this.overDosage = true;
        } else {
          this.overDosage = false;
        }
        this.sendScriptShow = true;
      },
      // 发送处方给患者
      sendScript() {
        let tabooArray = [];
        if (this.tabooData.length > 0) {
          this.tabooData.forEach(item => {
            let itemArray = item.split('与');
            tabooArray.push({
              name1: itemArray[0],
              name2: itemArray[1]
            })
          })
        }
        const postData = {
          pat_id: this.$route.query.pat_id,
          doc_id: this.userInfo.user_id,
          self_reported: this.condition,
          diagnose: this.diagnoseText,
          type: this.formulationType,
          company_name: this.companyname,
          content: this.herbList,
          dose: this.dosage,
          dosage: this.dosagePerDay,
          use_type: this.usage,
          // 如果为外用每剂分次服用则为0
          usage_direction: this.usage == 1 ? this.perDosage : 0,
          // 膏方制作费
          paste_price: this.selectedPaste == 1 ? this.pastePrice * 100 : 0,
          advice: this.attentionText,
          excess: this.excessHerbs.join(','),
          ori_price: this.normalPrice,
          price: this.finalPrice,
          drug_taboo: tabooArray,
          push_money: this.pushMoney,
          ele_id: this.photoPresDataID,
          exp_price: this.expressPrice,
          doc_star: this.doc_star
        }
        this.sendScriptShow = false;
        console.log('postData')
        console.log(postData)
        // return ;
        this.$toast.loading({
          duration: 0,
          forbidClick: true,
          loadingType: 'spinner',
          message: '提交中'
        });

        this.$root.post('/addPrescription', postData).then(data => {
          this.$toast.clear();
          if (data.status == 1) {
            if (data.is_audit == 1) {
              // 无需审核的话直接发送处方卡片
              let _this = this;

              //如果是电子拍照处方则不发送卡片信息，由服务端发送微信信息
              if (this.photoPresDataID == 0) {
                // 发送自定义的处方卡片
                let conversationType = RongIMLib.ConversationType.PRIVATE;
                let targetId = this.$route.query.pat_id.toString();

                let msg = new RongIMClient.RegisterMessage.PreMessage({
                  username: data.info.username,
                  type: data.info.type,
                  diagnose: data.info.diagnose,
                  create_time: data.info.create_time,
                  birthday: data.info.birthday,
                  gender: data.info.gender,
                  id: data.info.id,
                })
                RongIMClient.getInstance().sendMessage(conversationType, targetId, msg, {
                  onSuccess: function(message) {
                    _this.$notify({
                      background: '#00848A',
                      message: '提交成功，处方正在审核中'
                    });
                    _this.$root.post('/addChatLog', {
                      send_id: _this.userInfo.user_id,
                      to_id: targetId,
                      type: 5,
                      channel_type: 1,
                      content: JSON.stringify(message),
                      create_time: parseInt(message.sentTime / 1000),
                    }).then(data => {
                      console.log(data);
                    })
                    // 为了正确获取聊天页的历史消息，需要做一个1秒的延迟
                    setTimeout(() => {
                      RongIMClient.getInstance().getHistoryMessages(conversationType, targetId, 0, 2, {
                        onSuccess(list) {
                          console.log('发完处方1000毫秒后获取历史消息', list);
                        },
                        onError(error) {
                          console.log(error)
                        }
                      })
                      _this.$router.go(-1);
                    }, 1000)

                  },
                  onError: function(errorCode) {
                    console.log('发送自定义消息失败', errorCode);
                  }
                })
              } else {
                console.log("没有发送卡片信息")
                _this.$notify({
                  background: '#00848A',
                  message: '处方信息提交成功'
                });
                _this.$router.push('/doctor/consulting-room');
              }


            } else if (data.is_audit == 2) {
              // 需要审核的话直接显示成功文案
              this.$notify({
                background: '#00848A',
                message: '提交成功，处方正在审核中'
              });
              setTimeout(() => {
                this.$router.go(-1);
              }, 1000);
            }

          } else {
            this.$notify(data.msg);
          }
        })
      },
      // 保存到处方模板
      saveTemplate() {
        if (this.herbList.length <= 0) {
          this.$notify('请先添加一个处方');
          return;
        }
        this.saveToTemplateShow = true;
      },
      saveTemplateAction() {
        if (!this.saveTemplateName) {
          this.$notify('请输入处方名称');
          return;
        };
        if (this.herbList.length <= 0) {
          this.$notify('请先添加一个处方');
          return;
        }
        return;
        this.scriptSaving = true;
        this.$root.post('/addPreTmp', {
          title: this.saveTemplateName,
          doc_id: this.userInfo.user_id,
          content: this.herbList,
          id: 0
        }).then(data => {
          this.scriptSaving = false;
          if (data.status == 1) {
            let message = '保存处方模板成功';
            // 标记已保存
            this.savedTemplate = true;
            this.$notify({
              background: '#00848A',
              message: message
            });
            this.saveToTemplateShow = false;
          } else {
            this.$notify(data.msg);
          }
        })
      }
    },


    filters: {
      floatTypeFilter(type) {
        if (type == 'plus') {
          return '+';
        } else {
          return '-';
        }
      },
      formulationTypeFilter(type) {
        switch (type) {
          case 1:
            return '中药饮片';
            break;
          case 2:
            return '配方颗粒';
            break;
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Doctor/Diagnose/diagnose.vue